<template>
<MainLayout>
  <div>
    <!-- <img src="@/assets/404.png" alt="" class="notfound" /> -->
    <main>
      <div class="container">
        <div class="row">
          <!-- <div class="col-md-4 align-self-center img-notfound">       
            <img src="/img/logo.2f945291.png" alt="" width="300px" height="300px">
          </div> -->
          <div class="col-md-12 align-self-center">
            <h1>404</h1>
            <h2>UH OH! You're lost.</h2>
            <p>The page you are looking for does not exist.
              How you got here is a mystery. But you can click the button below
              to go back to the homepage.
            </p>
            <button class="btn green" @click="$router.go(-1)">Return</button>
          </div>
        </div>
      </div>
    </main>
  </div>
</MainLayout>
</template>

<script>
  import MainLayout from "@/components/layout/MainLayout.vue";
  export default {
    name: 'VideoPlayer',
    components: {
          MainLayout,       
    },
  }
</script>

<style scoped>
  :root {
    --blue: #0e0620;
    --white: #fff;
    --green: #2ccf6d;
  }
  html,
  body {
    height: 100%;
  }
  body {
    font-family:"Nunito Sans";
    color: var(--blue);
    font-size: 1em;
  }
  .container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;   
  }
  button {
    font-family:"Nunito Sans";
  }
  ul {
    list-style-type: none;
    padding-inline-start: 35px;
  }
  svg {
    width: 100%;
    visibility: hidden;
  }
  h1 {
    font-size: 7.5em;
    margin: 15px 0px;
    font-weight:bold;
  }
  h2 {
    font-weight:bold;
  }

  .btn {
    z-index: 1;
    overflow: hidden;
    background: transparent;
    position: relative;
    padding: 8px 50px;
    border-radius: 30px;
    cursor: pointer;
    font-size: 1em;
    letter-spacing: 2px;
    transition: 0.2s ease;
    font-weight: bold;
    margin: 5px 0px;
    &.green {
      border: 4px solid var(--green);
      color: var(--blue);
      &:before {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        width: 0%;
        height: 100%;
        background: var(--green);
        z-index: -1;
        transition: 0.2s ease;
      }
      &:hover {
        color: var(--white);
        background: var(--green);
        transition: 0.2s ease;
        &:before {
          width: 100%;
        }
      }
    }
  }
  @media screen and (max-width:768px) {
    body {
      display:block;
    }
    .container {
      margin-top:70px;
      margin-bottom:70px;
    }
  } 
</style>
